import { Directive, ElementRef, EventEmitter, Output } from '@angular/core';

import { fromEvent, merge, of, timer } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Directive({
   selector: '[long-press]'
})
export class LongPressDirective {
   threshold = 500;

   @Output()
   longPress = new EventEmitter();

   constructor( private elementRef: ElementRef ) {
      const start = merge(
         fromEvent<MouseEvent>( this.elementRef.nativeElement, 'mousedown' ),
         fromEvent( this.elementRef.nativeElement, 'touchstart' ),
      ).pipe( map( _ => true ));

      const end = merge(
         fromEvent<MouseEvent>( this.elementRef.nativeElement, 'mouseup' ),
         fromEvent( this.elementRef.nativeElement, 'touchend' ),
      ).pipe( map( _ => false ));

      merge( start, end ).pipe(
         switchMap( state => state ? timer( this.threshold, 100 ) : of( null )),
         filter( value => !!value ),
         untilDestroyed( this ),
      ).subscribe( _ => this.longPress.emit( new UIEvent( 'longPress' )) );
   }
}
